<template>
  <article
    v-observe-visibility="itemVisibility.getOptions('half')"
    :class="$style.record"
  >
    <a :href="record.url" :class="$style.image" @click="emitRecordClick()">
      <jtn-ui-image
        :src="recordImage.src"
        :sources="recordImage.sources"
        :loading="recordImage.loading"
        :decoding="recordImage.decoding"
        :hasCommercialLabel="recordImage.hasCommercialLabel"
        :aspectRatio="16 / 9"
        alt=""
      />
    </a>
    <div :class="$style.content">
      <div :class="$style.recordInfo">
        <a
          v-for="rubric of record.rubrics"
          :key="rubric.id"
          :class="$style.infoLink"
          :href="rubric.url"
          @click="emitRubricClicked()"
        >
        {{ rubric.text }}
        </a>
        <a
          v-for="format of record.formats"
          :key="format.id"
          :class="$style.infoLink"
          :href="format.url"
          @click="emitFormatClicked()"
        >
        {{ format.text }}
        </a>
        <a
          v-for="theme of record.themes"
          :key="theme.id"
          :class="[$style.infoLink, $style.theme]"
          :href="theme.url"
          @click="emitThemeClicked()"
        >
        {{ theme.text }}
        </a>
      </div>
      <a
        :class="$style.header"
        :href="record.url"
        @click="emitRecordClick()"
      >
        {{ record.header }}
      </a>
      <jtn-ui-record-statistics
        :class="$style.statistic"
        :commentsCount="recordComments.count"
        :commentsUrl="recordComments.url"
        :discussUrl="recordComments.url"
        :isCommentsAllowed="recordComments.isAllowed"
        :viewsCount="record.viewsCount"
        @commentsClicked="emitCommentsClicked()"
        @discussClicked="emitDiscussClicked($event)"
      />
    </div>
  </article>
</template>

<script>
import { ObserverVisibility } from '@jtnews/shared';
import { JtnUiImage, JtnUiRecordStatistics } from '@jtnews/jtn-ui';

export default {
  name: 'PersonalSelectionItem',
  components: {
    JtnUiRecordStatistics,
    JtnUiImage
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      itemVisibility: new ObserverVisibility('half'),
    };
  },
  computed: {
    recordImage() {
      return this.record.image;
    },
    recordComments() {
      return this.record.comments;
    }
  },
  mounted() {
    this.itemVisibility.event.subscribe((state) => {
      if(state.value) {
        this.$emit('visible');
      }
    });
  },
  beforeDestroy() {
    this.itemVisibility.destroy();
  },
  methods: {
    emitRubricClicked() {
      this.$emit('recordClicked', 'рубрику')
    },
    emitFormatClicked() {
      this.$emit('recordClicked', 'формат')
    },
    emitThemeClicked() {
      this.$emit('recordClicked', 'тему')
    },
    emitRecordClick() {
      this.$emit('recordClicked', 'материал')
    },
    emitCommentsClicked() {
      this.$emit('recordClicked', 'комментарии')
    },
    emitDiscussClicked(event) {
      this.$emit('discussClicked', event);
    }
  }
}
</script>

<style lang="scss" module>
@import 'personal-selection-item.styles';
</style>